import mixitup from "mixitup";

export const global = () => {

    



    /* Logic for fixed menu position. Adding background when scrolling, and removing background when on top of the page */
    document.addEventListener("DOMContentLoaded", function () {
        const menuToggle = document.getElementById('menu-toggle') as HTMLElement;
        const overlay = document.getElementById('overlay') as HTMLElement;

        menuToggle.addEventListener('click', () => {
            menuToggle.classList.toggle('active');
            overlay.classList.toggle('open');
        });

        //language-toggle
        const languageToggle = document.getElementById('language-navigation') as HTMLElement;
        const languageButton = document.getElementById('language-button') as HTMLElement;
        const languageMenu = document.getElementById('language-menu') as HTMLElement;
        if (languageToggle) {
            languageToggle.addEventListener('click', () => {
                // languageToggle.classList.toggle('active');
                languageButton.classList.toggle('active');
                languageMenu.classList.toggle('open');
            });
        }
   


        const siteHeader = document.querySelector('.site-header') as HTMLElement;
        if (siteHeader) {
            const pageScroll = () => {
                const scrollPosition = window.scrollY;
                const threshold = 1;

                if (scrollPosition > threshold) {
                    siteHeader.classList.add("is-fixed");
                    overlay.style.top = "70px";
                }
                if (scrollPosition === 0) {
                    siteHeader.classList.remove("is-fixed");
                    overlay.style.top = "100px";
                }
            }

            window.addEventListener('scroll', pageScroll);
        }
    });

    const siteHeader = document.querySelector('.site-header') as HTMLElement;
    const navigationList = document.querySelector('.navigation-list') as HTMLElement;

    // Dynamic adjustment to header if it is too wide under 1340px.
    if (siteHeader && navigationList) {
      const updateNavigationState = () => {
        const screenWidth = window.innerWidth;
        const navigationWidth = navigationList.offsetWidth;

        if (screenWidth < 1445 && navigationWidth > 1050) {
          navigationList.classList.add('navigation-crowded');
        } else {
          navigationList.classList.remove('navigation-crowded');
        }
      };

      // Run on load
      updateNavigationState();

      // Run on resize
      window.addEventListener('resize', updateNavigationState);
    }



    /* Videobutton for text & image/videoblock */
    const imageVideoControls = document.querySelector(".video-controls") as HTMLElement;
    const playPauseButton = document.querySelector(".controls-button") as HTMLButtonElement;
    const video = document.querySelector(".hero-block__video") as HTMLVideoElement;

    if (imageVideoControls) {
        if (playPauseButton) {
            playPauseButton.addEventListener("click", () => {
                playPauseButton.classList.toggle("active");

                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const scrollToDocumentationLink = document.getElementById('scroll-to-documentation');

        if (scrollToDocumentationLink) {
            scrollToDocumentationLink.addEventListener('click', (event) => {
                event.preventDefault();
                smoothScroll('#documentation');
            });
        }
    });

    function smoothScroll(targetSelector: string) {
        const targetElement = document.querySelector(targetSelector);

        if (targetElement instanceof HTMLElement) {
            window.scrollTo({
                top: targetElement.offsetTop,
                behavior: 'smooth'
            });
        }
    }


    document.addEventListener('DOMContentLoaded', () => {
        const containers = document.querySelectorAll('.document-items'); 

        if (containers.length === 0) return; 

        containers.forEach(container => {
            mixitup(container, {
                selectors: {
                    target: '.document-item', 
                },
                animation: {
                    enable: false, 
                }
            });
        });
    });

}